/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'snmp';
const componentName = 'snmp-trap-list-page';

const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const validateSettingsLabel = `${prefix}.validateSettingsLabel`;
export const snmpTitleLabel = `${prefix}.snmpTitleLabel`;

export const ENGLISH = {
    [headerLabel]: 'SNMP Trap',
    [validateSettingsLabel]: 'Validate Settings',
    [snmpTitleLabel]: 'Validate SNMP Trap Settings',
};
